angular.module('inoApp')
    .factory('serverExceptionInterceptor', ['$q', '$translate', function ($q, $translate) {
        var serverExceptionInterceptor = {
            responseError: handleResponseError
        };

        return serverExceptionInterceptor;

        function handleResponseError(response) {
            // In some cases (notably 403 from Web API), data will be an empty string and we don't want that.
            if (!response.data || typeof response.data === 'string')
                response.data = {};
            response.data.LocalizedErrorMessage = '';

            var isHandled = false;

            // 400 Bad Request
            if (response.status === 400 && response.data && response.data.modelState) {
                // A Bad Request error that is handled by the Web API controller.
                // We should have enough information to get a meaningful error message.

                var messagesSeparationElement = '<br />';

                //errorMessages = getDistinctElement(getErrorMessagesFromModelState(response.data.ModelState));
                errorMessages = getErrorMessagesFromModelState(response.data.modelState);

                // Add all the errors to the LocalizedErrorMessage separated by the separation element.
                for (var i = 0; i < errorMessages.length; i++) {
                    response.data.LocalizedErrorMessage += errorMessages[i];
                    if (i + 1 !== errorMessages.length)
                        response.data.LocalizedErrorMessage += messagesSeparationElement;
                }

                isHandled = true;
            }

            // 401 Unauthorized
            if (response.status === 401) {
                response.data.LocalizedErrorMessage = $translate.instant('error.NotAuthenticated');
                isHandled = true;
            }

            // 403 Forbidden
            if (response.status === 403) {
                response.data.LocalizedErrorMessage = $translate.instant('error.Unauthorized');
                isHandled = true;
            }

            // If the error wasn't handled, just add the default error text.
            if (!isHandled)
                response.data.LocalizedErrorMessage = $translate.instant('error.DefaultErrorMessage');

            return $q.reject(response);
        }

        function getErrorMessagesFromModelState(modelState) {
            var errorMessages = [];
            var defaultErrorText = $translate.instant('error.DefaultErrorMessage');

            // Loop in all property as we can have multiple error messages coming from the server.
            for (var property in modelState) {

                // To avoid logging inherited properties
                if (modelState.hasOwnProperty(property)) {

                    // Each property is an array of errors so, loop.
                    for (var i = 0; i < modelState[property].length; i++) {

                        var errorTextKey = 'error.' + modelState[property][i];
                        var errorText = $translate.instant(errorTextKey);

                        // If the error key is the same as the text, it means that we don't have any relevant error text to display
                        // so we just add the default error text to the response.
                        if (errorTextKey === errorText)
                            errorMessages.push(defaultErrorText);
                        else
                            errorMessages.push(errorText);
                    }
                }
            }

            return errorMessages;
        }

        //function getDistinctElement(a) {
        //    return a.reduce(function (p, c) {
        //        if (p.indexOf(c) < 0) p.push(c);
        //        return p;
        //    }, []);
        //}

    }])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('serverExceptionInterceptor');
    }]);